/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export const getCodeBlocks = (feature: BaseTibbit): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const currentSocket = Number(feature.getSettingValue('SOCKET'));
    const prevSocket = (currentSocket - 1).toString();
    const NAME = feature.getSettingValue('LIGHT_NAME');
    const { project } = feature;
    const ID = feature.getID();
    const connectedSocket = (Number(feature.getSettingValue('SOCKET')) - 1).toString();

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    'Tibbit 28 setup with 00_3
    if tbt28_init("${NAME}",NO,${NAME}_CLK,${NAME}_DATA,${NAME}_CHANNEL_NUM)=NG then
    sys.debugprint("SSI channel could not be allocated, using bit banging instead."+chr(10)+chr(13))
    end if`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare ${NAME}_CHANNEL_NUM as byte
        `,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim ${NAME}_CHANNEL_NUM as byte
        `,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
'sys.debugprint(str(tbt28_get(${NAME}_CHANNEL_NUM))+chr(10)+chr(13))
        `,
    });

    blocks.push({
        location: `var_${NAME}_update`,
        blockType: BlockType.CODE,
        template: `var_${NAME}_update_completed(tbt28_get(${NAME}_CHANNEL_NUM))`,
    });

    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const ${NAME}_CLK = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[0]}
const ${NAME}_DATA = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[1]}
                    `,
    });

    return blocks;
};
